import script from "./TaskWidget.vue?vue&type=script&lang=ts&setup=true"
export * from "./TaskWidget.vue?vue&type=script&lang=ts&setup=true"

import "./TaskWidget.vue?vue&type=style&index=0&id=b439f0e0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b439f0e0"]])

export default __exports__